import IconCarbonCheckmarkOutline from '@/shared/icons/IconCarbonCheckmarkOutline'
import IconCarbonWarningAlt from '@/shared/icons/IconCarbonWarningAlt'

const ComparatorLinkState = ({ row, t }) => {
  if (row.comparator_link_broken) {
    return (
      <IconCarbonWarningAlt
        color='#FF0000'
        size={32}
        title={t('organizationManagement:table.comparator_link_broken')}
      />
    )
  }

  if (!row.comparator_id) {
    return '-'
  }

  return <IconCarbonCheckmarkOutline color='#197676' size={32} />
}

export default ComparatorLinkState
